var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
if (window.NodeList && !NodeList.prototype.forEach) {
    // @ts-ignore
    NodeList.prototype.forEach = Array.prototype.forEach;
}
var CWS;
(function (CWS) {
    var Step = /** @class */ (function () {
        function Step(index) {
            var _this = this;
            this.select = function (val) {
                var matchFound = false;
                _this.answers.forEach(function (el) {
                    if (el.dataset.answer === val) {
                        matchFound = true;
                        el.setAttribute("data-selected", "1");
                        _this._selectedAnswer = val;
                        // Step 3 has Yes/No answers. Yes - shows "Continue" button, No - shows "View my regime" button.
                        switch (_this._selectedAnswer) {
                            case "Yes":
                                _this.el.querySelector("[data-continue]").style.display = "inline-block";
                                _this.el.querySelector("[data-finish]").style.display = "none";
                                break;
                            case "No":
                                _this.el.querySelector("[data-continue]").style.display = "none";
                                _this.el.querySelector("[data-finish]").style.display = "inline-block";
                                break;
                            default:
                                _this.el.querySelectorAll("button").forEach(function (el) { return el.style.display = "inline-block"; });
                        }
                    }
                    else {
                        el.removeAttribute("data-selected");
                    }
                });
                if (!matchFound) {
                    _this.el.querySelectorAll("button:not([data-start-again],[data-back])").forEach(function (el) { return el.style.display = "none"; });
                }
                return _this;
            };
            this.hide = function () {
                _this.el.style.display = "none";
                return _this;
            };
            this.show = function () {
                _this.el.style.display = "block";
                return _this;
            };
            this._index = index;
            this.el = container.querySelector("[data-step='" + index + "']");
            if (!this.el) {
                console.warn("Element \"[data-step='" + index + "']\" not found");
                return;
            }
            this.answers = this.el.querySelectorAll(answerSelector);
            this.answers.forEach(function (el) {
                el.addEventListener("click", function (e) {
                    e.preventDefault();
                    var answer = e.target;
                    _this.select(answer.dataset.answer);
                });
            });
            this.hide();
        }
        Object.defineProperty(Step.prototype, "index", {
            get: function () {
                return this._index;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Step.prototype, "selectedAnswer", {
            get: function () {
                return this._selectedAnswer;
            },
            enumerable: false,
            configurable: true
        });
        return Step;
    }());
    var BulkItemsCartAdder = /** @class */ (function () {
        function BulkItemsCartAdder(ids) {
            this.execute = function (callback) {
            };
            this._ids = ids;
        }
        return BulkItemsCartAdder;
    }());
    var containerSelector = "#shopify-section-quiz";
    var startQuizBtnSelector = "[data-quiz-start]";
    var introSelector = "[data-intro]";
    var stepSelector = "[data-step]";
    var answerSelector = "[data-answer]";
    var backBtnSelector = "[data-back]";
    var continueBtnSelector = "[data-continue]";
    var finishBtnSelector = "[data-finish]";
    var resultsSelector = "[data-results]";
    var resultButtonsContainerSelector = "[data-results-buttons]";
    var addToCartBtnSelector = "[data-atc]";
    var startAgainBtnSelector = "[data-start-again]";
    var addAllToCartBtnSelector = "[data-add-all-to-cart]";
    var finalBoxSelector = "[data-final]";
    var container = document.querySelector(containerSelector);
    var intro = container.querySelector(introSelector);
    var stepElements = container.querySelectorAll(stepSelector);
    var steps = new Array(stepElements.length);
    var backBtns = container.querySelectorAll(backBtnSelector);
    var continueBtns = container.querySelectorAll(continueBtnSelector);
    var finishBtns = container.querySelectorAll(finishBtnSelector);
    var startBtn = container.querySelector(startQuizBtnSelector);
    var resultsEl = container.querySelector(resultsSelector);
    var resultsElInitialHTML = resultsEl.innerHTML;
    var resultButtonsContainerEl = container.querySelector(resultButtonsContainerSelector);
    var startAgainBtns = container.querySelectorAll(startAgainBtnSelector);
    var addAllToCartBtn = container.querySelector(addAllToCartBtnSelector);
    var finalBox = container.querySelector(finalBoxSelector);
    var currentStepIndex;
    var hideStep = function (index) {
        if (!currentStepIndex) {
            return;
        }
        var step = new Step(index);
        step.hide();
    };
    var showStep = function (index) {
        if (index < 1 || index > stepElements.length) {
            console.warn("Quiz step #" + index + " doesn't exist.");
            return;
        }
        hideStep(currentStepIndex);
        var step = new Step(index);
        step.show();
        currentStepIndex = index;
    };
    var removeClass = function (el, className) {
        if (el.classList)
            el.classList.remove(className);
        else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    };
    // Continue
    var back = function () {
        hideStep(currentStepIndex);
        if (currentStepIndex === 1) {
            startAgain();
        }
        else {
            showStep(--currentStepIndex);
        }
    };
    var next = function () {
        hideStep(currentStepIndex);
        showStep(++currentStepIndex);
    };
    // Show results
    var finish = function () {
        hideStep(currentStepIndex);
        resultsEl.style.display = "block";
        finalBox.style.display = "block";
        loadResults();
    };
    var updateHeaderCartIconItemCount = function () {
        $.getJSON('/cart.js', function (cart) {
            $('[data-cart-count],[data-cart-popup-cart-quantity],#CartCount').text(cart.item_count).parent().removeClass("hide");
        });
    };
    // Load results
    var loadResults = function () {
        var resultAnswers = new Array(steps.length);
        for (var i = 0; i < steps.length; i++) {
            resultAnswers[i] = steps[i].selectedAnswer;
        }
        resultsEl.innerHTML = resultsElInitialHTML;
        loadResultsTaggedWith(resultAnswers, function () {
            if (!resultsEl.innerHTML.length) {
                resultsEl.innerHTML = "No results found";
            }
        });
    };
    // Hide steps
    stepElements.forEach(function (el, index) {
        steps[index] = new Step(Number(el.dataset.step));
    });
    // Hide "continue" buttons
    continueBtns.forEach(function (el) { return el.style.display = "none"; });
    // Hide "view results" buttons
    continueBtns.forEach(function (el) { return el.style.display = "none"; });
    // Hide "results" div
    finalBox.style.display = "none";
    removeClass(resultsEl, "result-slider");
    startBtn.addEventListener("click", function () {
        intro.style.display = "none";
        showStep(1);
    });
    continueBtns.forEach(function (el) { return el.addEventListener("click", next); });
    backBtns.forEach(function (el) { return el.addEventListener("click", back); });
    finishBtns.forEach(function (el) {
        el.style.display = "none";
        el.addEventListener("click", finish);
    });
    var loadResultsTaggedWith = function (tags, callback) {
        var requestTags = tags.join("-").replace(/quiz-(type|texture|style)-/g, '');
        var xhr = new XMLHttpRequest();
        xhr.open("GET", "/collections/all/" + requestTags + "?view=json", true);
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 400) { // success
                var results_1 = JSON.parse(xhr.responseText);
                var tplHTML = document.querySelector("#quiz-result-tpl").innerHTML;
                var responseLength = 0;
                var outputHTML = "";
                if (results_1.length > 0) {
                    // Object with regular expressions for each item attribute from the results.
                    var re_1 = {};
                    Object.keys(results_1[0]).forEach(function (attr) {
                        re_1[attr] = new RegExp("{" + attr + "}", "g");
                    });
                    var _loop_1 = function (i) {
                        if ("CWS_QUIZ_MAP_TO_SAMPLES" in window && globalThis.CWS_QUIZ_MAP_TO_SAMPLES && !results_1[i]["sample_id"]) {
                            return "continue";
                        }
                        if (results_1[i].content === null) {
                            results_1[i].content = "";
                        }
                        var itemHTML = tplHTML;
                        Object.keys(results_1[i]).forEach(function (val) {
                            if (val === "id" && globalThis.CWS_QUIZ_MAP_TO_SAMPLES) {
                                itemHTML = itemHTML.replace(re_1[val], results_1[i].sample_id);
                            }
                            else {
                                itemHTML = itemHTML.replace(re_1[val], results_1[i][val]);
                            }
                        });
                        outputHTML += itemHTML;
                    };
                    for (var i = 0; i < results_1.length; i++) {
                        _loop_1(i);
                    }
                }
                resultsEl.innerHTML = outputHTML;
                if (resultButtonsContainerEl) {
                    resultButtonsContainerEl.style.display = "block";
                }
                if (callback) {
                    callback();
                }
                $('.product-card-slide').each(function (index) {
                    $(this).find('.quiz-product-type span').text(index + 1);
                });
            }
        };
        xhr.send();
    };
    resultsEl.addEventListener("click", function (e) {
        // loop parent nodes from the target to the delegation node
        // @ts-ignore
        for (var target = e.target; target && target != this; target = target.parentNode) {
            // @ts-ignore
            if (target.matches(addToCartBtnSelector)) {
                handleAtcBtnClick(target);
                break;
            }
        }
    }, false);
    var handleAtcBtnClick = function (el) {
        el.disabled = true;
        var innerHTML = el.innerHTML;
        el.innerText = "adding...";
        addToCart(Number(el.dataset.atc), 1, function (result) {
            if (result.success) {
                el.innerText = "added";
                updateHeaderCartIconItemCount();
                setTimeout(function () {
                    el.innerHTML = innerHTML;
                    el.disabled = false;
                }, 2000);
            }
            else {
                if (result.msg) {
                    alert(result.msg);
                }
                el.disabled = false;
                el.innerHTML = innerHTML;
            }
        });
    };
    var addToCart = function (id, qty, callback) {
        if (qty === void 0) { qty = 1; }
        var result = { id: id, success: undefined };
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/cart/add.js", true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 400) { // success
                result.success = true;
                var resp = JSON.parse(xhr.responseText);
                if ("dataLayer" in window) {
                    // @ts-ignore
                    window.dataLayer.push({
                        "event": "add_to_cart",
                        "type": resp.items[0].product_type,
                        "name": resp.items[0].title,
                        "price": "$" + (resp.items[0].price / 100).toFixed(2),
                        "quantity": 1
                    });
                }
            }
            else { // we reached our target server, but it returned an error
                result = __assign(__assign({}, result), { success: false, msg: "Unexpected server error" });
                if (xhr.status == 422) {
                    try {
                        var resp = JSON.parse(xhr.responseText);
                        if ("message" in resp && "description" in resp) {
                            result.msg = resp.message + ": " + resp.description;
                        }
                    }
                    catch (e) { }
                }
            }
            if (callback) {
                callback(result);
            }
        };
        xhr.onerror = function () {
            result = __assign(__assign({}, result), { success: false, msg: "Unexpected connection error" });
            if (callback) {
                callback(result);
            }
        };
        xhr.send("items[0][quantity]=" + qty + "&items[0][id]=" + id);
    };
    var startAgain = function () {
        finalBox.style.display = "none";
        resultsEl.innerHTML = resultsElInitialHTML;
        if (resultButtonsContainerEl) {
            resultButtonsContainerEl.style.display = "none";
        }
        intro.style.display = "block";
        steps.forEach(function (step) { return step.select(null).hide(); });
        $(resultsSelector).attr('class', '');
    };
    startAgainBtns.forEach(function (el) { return el.addEventListener("click", startAgain); });
    function addAllToCart(callback) {
        // get result product variant IDs
        var variantIds = [];
        resultsEl.querySelectorAll(addToCartBtnSelector).forEach(function (el) { return variantIds.push(Number((el.dataset.atc))); });
        // leave unique IDs only, remove duplicates created by Slick slider
        variantIds = variantIds.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
        var queue = new AddToCartQueue(variantIds);
        queue.run(callback);
    }
    addAllToCartBtn === null || addAllToCartBtn === void 0 ? void 0 : addAllToCartBtn.addEventListener("click", function (e) {
        var el = e.target;
        el.disabled = true;
        var innerHTML = el.innerHTML;
        el.innerText = "adding...";
        addAllToCart(function (output) {
            if (output.length) {
                alert(output);
            }
            el.innerText = "added";
            updateHeaderCartIconItemCount();
            setTimeout(function () {
                el.innerHTML = innerHTML;
                el.disabled = false;
            }, 2000);
        });
    });
    var AddToCartQueue = /** @class */ (function () {
        function AddToCartQueue(ids) {
            this._ids = ids;
        }
        AddToCartQueue.prototype.run = function (callback) {
            var _this = this;
            var id = this._ids.shift();
            var output = "";
            if (id) {
                addToCart(id, 1, function (resp) {
                    if (!resp.success) {
                        output += " - " + resp + ".msg\n";
                    }
                    _this.run(callback);
                });
            }
            else {
                callback(output);
            }
        };
        return AddToCartQueue;
    }());
})(CWS || (CWS = {}));
